var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ds-modal", {
    attrs: { open: _vm.showModal },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "modal-dialog go-modal-connect" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "modal-title" }, [
                    _vm._v(_vm._s(_vm.$t("scrap-agent.login"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.handleCloseModal.apply(null, arguments)
                        },
                      },
                    },
                    [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "go-form-connect-login" }, [
                    _c("div", { staticClass: "go-form-header" }, [
                      _c("div", { staticClass: "go-brand" }, [
                        _c("div", { staticClass: "go-brand-symbol" }, [
                          _c("img", {
                            attrs: {
                              src: "https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/facebook.png",
                              alt: "Facebook",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v("Facebook")]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.showInputName
                      ? _c("div", { staticClass: "form-group" }, [
                          _c("div", { staticClass: "go-block-between" }, [
                            _c("label", { staticClass: "go-form-label" }, [
                              _vm._v("Input Username"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "go-input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.accountName,
                                  expression: "accountName",
                                },
                              ],
                              staticClass: "go-form-control",
                              attrs: {
                                type: "text",
                                placeholder: "Enter username",
                              },
                              domProps: { value: _vm.accountName },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.accountName = $event.target.value
                                },
                              },
                            }),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-form-body" }, [
                      _c("div", { staticClass: "text-center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "google-btn",
                            attrs: { type: "button" },
                            on: { click: _vm.openFacebookPopup },
                          },
                          [_vm._v(_vm._s(_vm.$t("scrap-agent.login")))]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }